module.exports = __webpack_public_path__ + "static/media/pkstat.08311050.png";